import type { EdgeRenderingService } from '../rendering';

/**
 * Global ref to EdgeRenderingService
 * Set by ReactiveEdgeService when canvas is active
 */
let globalEdgeRenderingServiceRef: EdgeRenderingService | null = null;

/**
 * Sets the EdgeRenderingService for the settings panel.
 * Called by EdgeSidebarSetup (which is now EdgeSettingsSetup).
 */
export function setCanvasEdgesRenderingService(
  service: EdgeRenderingService | null
): void {
  globalEdgeRenderingServiceRef = service;
}

/**
 * Gets the current EdgeRenderingService reference.
 */
export function getCanvasEdgesRenderingService(): EdgeRenderingService | null {
  return globalEdgeRenderingServiceRef;
}
